export const companiesHouseUrl =
  'https://find-and-update.company-information.service.gov.uk/company/';
